export enum RecordingConsent {
  ONE_PARTY = "ONE_PARTY",
  ALL_PARTY = "ALL_PARTY",
  NEEDS_REVIEW = "NEEDS_REVIEW",
}

export const RECORDING_CONSENT_LABELS: Record<RecordingConsent, string> = {
  [RecordingConsent.ONE_PARTY]: "One party",
  [RecordingConsent.ALL_PARTY]: "All parties",
  [RecordingConsent.NEEDS_REVIEW]: "Needs review",
};
